export enum QuestionnaireSectionStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
  Untouched = 'Untouched'
}

export interface IQuestionnaireSection {
  name: string;
  status: QuestionnaireSectionStatus;
  id: number;
  iFrameSource: string;
  isAuditSection: boolean;
  totalCommentCount: number;
  unreadCommentCount: number;
}
